const componentFinder = data => component => id =>
  data && data[component] && data[component].edges && data[component].edges &&
  data[component].edges.find(({ node }) => (node.id === id));

export default componentFinder;